"use client";

import { FC } from "react";
import {
  IStep,
  SimpleProgressSteps,
} from "apps/website/components/feature/Navigation/SimpleProgressSteps/SimpleProgressSteps";

interface ProgressStepsProps {
  hideProgressSteps: boolean | undefined;
  pathname: string;
  steps: IStep[];
  bgColor?: string;
}

export const ProgressSteps: FC<ProgressStepsProps> = ({
  hideProgressSteps = false,
  pathname,
  steps,
  bgColor = "bg-white",
}) => {
  if (hideProgressSteps) {
    return null;
  }

  const stepBgColor = bgColor === "bg-light-grey" ? "light" : "light-grey";

  return (
    <div className={`flex justify-center flex-col w-full px-4 lg:px-0 mx-auto ${bgColor}`}>
      <SimpleProgressSteps
        steps={steps}
        currentSlug={pathname}
        styleOptions={{ stepBgColor }}
      />
    </div>
  );
};
